<script lang="ts">
  import type { OperationModel } from '../../../models/api/OperationModel';
  import { t } from 'svelte-i18n';

  export let operation: OperationModel;
</script>

<section>
  <div class="grid grid-cols-2">
    <div class="grid grid-cols-1">
      <div>
        <h4>Impact sur l'environnement</h4>
        <ul>
          <li>{operation.environnementTonnesCO2Evitees} tonnes de CO2 évitées</li>
          <li>{operation.environnementImpact}</li>
        </ul>
      </div>
      <div>
        <h4>Acteurs Locaux</h4>
        <p>{@html operation.listeActeursDeveloppementLocal}</p>
      </div>
    </div>
    <div>
      <h4>Description technique</h4>
      {@html operation.descriptionTechnique}
    </div>
  </div>
</section>

{#if operation.planningPrevisionnel}
  <section>
    <h3>{$t('operation.realEstateProjectInfos.planedSchedule')}</h3>
    {@html operation.planningPrevisionnel}
  </section>
{/if}
